<template>
    <div class="row g-4">

        <!-- Card 1 -->
        <div class="col-12 col-md-6 col-lg-4">
            <div class="feature-card h-100 text-center">
                <div class="feature-image">
                    <img :src="featureImages[30]" alt="Free items when you join" />
                </div>
                <div class="feature-body">
                    <h3 class="feature-title mt-3">Free Items When You Join</h3>
                    <p class="feature-text">
                        Use code <span class="feature-code">::ref</span> for a free $5 donated,
                        mystery box bundle, and powerful boosters to kick-start your adventure.
                    </p>
                </div>
            </div>
        </div>

        <!-- Card 2 -->
        <div class="col-12 col-md-6 col-lg-4">
            <div class="feature-card h-100 text-center">
                <div class="feature-image">
                    <img :src="featureImages[19]" alt="Multiple perk systems" />
                </div>
                <div class="feature-body">
                    <h3 class="feature-title mt-3">Multiple Perk Systems</h3>
                    <p class="feature-text">
                        Forge your playstyle with Combat Relics, Utility Perks, and PvM Sigils.
                        Build your character exactly how you want.
                    </p>
                </div>
            </div>
        </div>

        <!-- Card 3 -->
        <div class="col-12 col-md-6 col-lg-4">
            <div class="feature-card h-100 text-center">
                <div class="feature-image">
                    <img :src="featureImages[1]" alt="All Raids + Custom Raid" />
                </div>
                <div class="feature-body">
                    <h3 class="feature-title mt-3">All 3 Raids + Custom Raid</h3>
                
                    <p class="feature-text">
                    Take on 1:1 CoX, ToB, and ToA, plus conquer our custom
                    roguelike wave-based raid, Trial of the Exiled.
                    </p>
                </div>
                
            </div>
        </div>

    </div>
</template>

<script setup>
const context = require.context('@/assets/img/media', false, /\.(png|jpe?g|webp)$/)
const featureImages = context.keys().map(key => context(key))
</script>

<style scoped>
/* Card container */
.feature-card {
    background: #050404; /* flat dark behind everything */
    border: 1px solid #5b3a16;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    transition: transform 0.2s ease-out, box-shadow 0.2s ease-out, border-color 0.2s ease-out;
}

.feature-card::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    border: 1px solid rgba(246, 198, 91, 0.12);
    pointer-events: none;
}

.feature-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.85);
    border-color: #f6c65b;
}

/* Header image area */
.feature-image {
    width: 100%;
    height: 160px; /* tweak this if you want more/less image height */
    flex-shrink: 0;
}

@media (min-width: 992px) {
    .feature-image {
        height: 180px; /* a touch taller on desktop */
    }
}

.feature-image img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    transition: transform 0.25s ease-out;
}

.feature-card:hover .feature-image img {
    transform: scale(1.05);
}

.feature-body {
    padding: 1.4rem 1.4rem 1.8rem;

    /* Base soft-modern dark grey */
    background: #1a1a1c; /* same tone used in many game UIs */

    /* Subtle gold dust glow at the bottom */
    position: relative;
}

.feature-body::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 45%;   /* how much of the bottom glow rises */
    pointer-events: none;

    background: radial-gradient(
        ellipse at bottom,
        rgba(246, 198, 91, 0.25) 0%,  /* soft faint gold */
        rgba(246, 198, 91, 0.14) 30%,
        rgba(246, 198, 91, 0.06) 55%,
        rgba(246, 198, 91, 0.01) 80%,
        rgba(246, 198, 91, 0) 100%
    );

    filter: blur(12px); /* makes it soft, not harsh */
}


.feature-title {
    font-family: "Cinzel", "Times New Roman", serif;
    font-size: 1.1rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #f6c65b;
}

.feature-text {
    margin-top: 0.6rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    font-size: 0.9rem;
    line-height: 1.5;
    color: #e5dfcf;
}

.feature-code {
    color: #ff9b2c;
    font-weight: 600;
    font-family: "Consolas", monospace;
}
</style>